<template>
    <b-table
        bordered
        :fields="fields"
        :items="data"
    >
    </b-table>  
</template>
<script>
    import fields from './fields';
    export default {
        data(){
            return {
                fields: fields
            }
        },
        props: {
            data: {
                required: true
            }
        }
    }
</script>
